import { currencyFormatterNoCents } from '@thesavingsgroup/utils/currencyFormatterNoCents';
import { isNonEmptyString } from '@thesavingsgroup/utils/isNonEmptyString';
import { stripNonNumericCharacters } from '@thesavingsgroup/utils/stripNonNumericCharacters';

export const toCurrencyString = (
  numericValue?: string | number | null,
): string => {
  const valueAsString = stripNonNumericCharacters(numericValue);

  return isNonEmptyString(valueAsString)
    ? currencyFormatterNoCents.format(Number(valueAsString))
    : '';
};
